const initialState = {
  showDetailData: {
  },
  showDetailGray: false,
};

// 演出详情
export default function receiveDetailData(state = initialState, action) {
  switch (action.type) {
  case 'SHOW_DETAIL_DATA':
    return { ...state, showDetailData: action.payload };
  case 'SHOW_DETAIL_GRAY':
    return { ...state, showDetailGray: action.payload };
  default:
    return state;
  }
}